module.exports = __webpack_public_path__ + "img/KM.7421d13b.png";